<ngx-spinner
  appendTo="body"
  bdColor="rgba(40,47,57,0.85)"
  size="medium"
  color="#8bcd13"
  type="line-scale"
>
</ngx-spinner>
<!-- *ngIf="show" -->

<footer>
  <div class="container">
    <div class="site-info">
      <span
        >{{ "footer.developed" | translate }} &copy; {{ copyrightYear }}</span
      >
      v3.0.0
    </div>
    <div class="footer-nav" *ngIf="globalSettings">
      <ul>
        <li>
          <a (click)="showDialog('TC')">{{ "footer.tnc" | translate }}</a>
        </li>
        <li>
          <a (click)="showDialog('PP')">{{ "footer.pp" | translate }}</a>
        </li>
        <li>
          <a (click)="showDialog('SA')">{{ "footer.sa" | translate }}</a>
        </li>
        <li>
          <a href="https://qunote.com/contact/" target="_blank">{{
            "footer.con" | translate
          }}</a>
        </li>
      </ul>
    </div>
  </div>
  <p-dialog [focusOnShow]="false"
    header="{{ 'footer.tc_page_heading' | translate }}"
    [(visible)]="displayTC"
    [modal]="true"
    [draggable]="false"
    [blockScroll]="true"
    styleClass="page-modal"
  >
    <div
      class="modal-body"
      [innerHTML]="pageContent.terms_conditions_page"
    ></div>
    <div  >
      <div
        class="page-last-updated"
        [innerHTML]="
          'footer.tc_page_updated'
            | translate : { DATE: pageContent.terms_conditions_page_updated }
        "
      ></div>
      <input
        type="button"
        class="btn btn-secondary"
        value="{{ 'footer.close' | translate }}"
        (click)="closeDialog('TC')"
      />
    </div>
  </p-dialog>
  <p-dialog [focusOnShow]="false"
    header="{{ 'footer.pp_page_heading' | translate }}"
    [(visible)]="displayPP"
    [modal]="true"
    [draggable]="false"
    [blockScroll]="true"
    styleClass="page-modal"
  >
    <div class="modal-body" [innerHTML]="pageContent.privacy_policy_page"></div>
    <div  >
      <div
        class="page-last-updated"
        [innerHTML]="
          'footer.pp_page_updated'
            | translate : { DATE: pageContent.privacy_policy_page_updated }
        "
      ></div>
      <input
        type="button"
        class="btn btn-secondary"
        value="{{ 'footer.close' | translate }}"
        (click)="closeDialog('PP')"
      />
    </div>
  </p-dialog>
  <p-dialog [focusOnShow]="false"
    header="{{ 'footer.sa_page_heading' | translate }}"
    [(visible)]="displaySA"
    [modal]="true"
    [draggable]="false"
    [blockScroll]="true"
    styleClass="page-modal"
  >
    <div
      class="modal-body"
      [innerHTML]="pageContent.service_agreement_page"
    ></div>
    <div  >
      <div
        class="page-last-updated"
        [innerHTML]="
          'footer.sa_page_updated'
            | translate : { DATE: pageContent.service_agreement_page_updated }
        "
      ></div>
      <input
        type="button"
        class="btn btn-secondary"
        value="{{ 'footer.close' | translate }}"
        (click)="closeDialog('SA')"
      />
    </div>
  </p-dialog>
</footer>

<!-- system message display -->
<app-system-message
  [showSystemMessage]="showSystemMessage"
  [systemMessage]="systemMessage"
  *ngIf="globalSettings"
></app-system-message>
